import axios from 'axios';

const baseUrl = process.env.VUE_APP_BASE_URL;
const apiV1 = process.env.VUE_APP_API_V1;

class AuthService {

   login(user, resources) {
      return axios.post(`${baseUrl + apiV1}/auth/authenticate`, {
         email: user.email,
         password: user.password,
         resources
      })
         .then(response => {
            if (response.data.token) {
               const res = {
                  token: response.data.token,
                  user: response.data.user
               }
               localStorage.setItem('user', JSON.stringify(res))
            }
            return response.data;
         })
   }

   logout() {

      localStorage.removeItem('user');
   }

   /*return s.response.data*/
   forgotPassword(email) {
      return axios.post(`${baseUrl + apiV1}/auth/forgot_password`, {email})
         .then(
            success => {
               return Promise.resolve(success)
            },
            err => {
               return Promise.reject(err)
            }
         )
   }


    CheckInfo(data) {
        return axios.patch(`${baseUrl + apiV1}/auth/check-info`, data)
    }


}

export default new AuthService();
